import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.map.js";
import { getChannelList, saveChannelAuth, getChannelAuth } from "@/api/channel";
export default {
  name: "Datas",
  data: function data() {
    return {
      isIndeterminate: false,
      checkAll: true,
      channelList: [],
      dataAuthorityId: [],
      needConfirm: false,
      checkedChannels: [],
      isAllChannel: false
    };
  },
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  methods: {
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.authAppEnter();
    },
    all: function all() {
      this.dataAuthorityId = _toConsumableArray(this.authoritys);
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    //   选择
    selectAuthority: function selectAuthority() {
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    handleCheckAllChange: function handleCheckAllChange(value) {
      this.isAllChannel = value;
      if (value) {
        this.checkedChannels = this.channelList.map(function (item) {
          return item.channel_id;
        });
      } else {
        this.checkedChannels = [];
      }
      this.updateCheckStatus();
      this.needConfirm = true;
    },
    handleCheckedAppsChange: function handleCheckedAppsChange() {
      this.isAllChannel = false;
      this.updateCheckStatus();
      this.needConfirm = true;
    },
    authAppEnter: function authAppEnter() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var channels, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              channels = _this.isAllChannel ? ["all"] : _this.checkedChannels;
              _context.next = 3;
              return saveChannelAuth({
                authorityId: _this.row.authorityId,
                channels: channels
              });
            case 3:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "设置成功"
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateCheckStatus: function updateCheckStatus() {
      this.checkAll = this.checkedChannels.length == this.channelList.length;
      this.isIndeterminate = this.checkedChannels.length > 0 && this.checkedChannels.length < this.channelList.length;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var channelListRs, appAuth;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getChannelList();
          case 2:
            channelListRs = _context2.sent;
            _this2.channelList = channelListRs.data;
            _context2.next = 6;
            return getChannelAuth({
              authorityId: _this2.row.authorityId
            });
          case 6:
            appAuth = _context2.sent;
            // 识别 "all"：后端返回 ["all"] 表示全部渠道权限
            if (appAuth.data && appAuth.data.length === 1 && appAuth.data[0] === "all") {
              _this2.isAllChannel = true;
              _this2.checkAll = true;
              _this2.checkedChannels = _this2.channelList.map(function (item) {
                return item.channel_id;
              });
            } else {
              _this2.isAllChannel = false;
              _this2.checkedChannels = appAuth.data;
              _this2.updateCheckStatus();
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};